import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  AppBar, Toolbar, Typography, IconButton, Icon, Hidden,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';


const styles = {
  title: {
    flexGrow: 1,
    fontWeight: 500,
  },
  logoutButton: {
    flexGrow: 0,
  },
  openButton: {
    color: '#ffffff',
  },
  logo: {
    height: '48px',
  },
  dateRange: {
    background: '#dedede',
    color: 'black',
    textAlign: 'center',
  },
  refreshButton: {
    color: 'white',
  },
};

class Bar extends Component {
  renderDateRange = () => {
    const { dateRange } = this.props;
    const { startDate, endDate } = dateRange;
    const format = 'DD.MM.YYYY HH:mm';
    const sd = moment.unix(startDate).format(format);
    const ed = moment.unix(endDate).format(format);


    return (
      <Hidden smUp>
        <div style={styles.dateRange}>{`${sd} - ${ed}`}</div>
      </Hidden>
    );
  }

  renderButton() {
    const { toggleFiltersOpen, filtersOpen } = this.props;
    if (filtersOpen) return null;
    return (
      <IconButton
        color="inherit"
        aria-label="Open drawer"
        onClick={() => toggleFiltersOpen()}
        classes={{ root: 'desktop-drawer-button' }}
      >
        <MenuIcon />
      </IconButton>
    );
  }

  render() {
    const { filtersOpen, loadAllReportData } = this.props;

    return (
      <AppBar
        position="fixed"
        color="secondary"
        classes={{ root: `app-bar ${filtersOpen ? 'open' : 'closed'} doNotPrint` }}
      >
        <Toolbar disableGutters={!filtersOpen}>
          {this.renderButton()}
          <Typography style={styles.title}>
            REPORTS
          </Typography>
          <IconButton onClick={loadAllReportData} style={styles.refreshButton}>
            <Icon>refresh</Icon>
          </IconButton>
        </Toolbar>
        {this.renderDateRange()}
      </AppBar>
    );
  }
}

Bar.propTypes = {
  filtersOpen: PropTypes.bool,
  dateRange: PropTypes.object.isRequired,
  userName: PropTypes.string,
  useDesktopLayout: PropTypes.bool.isRequired,
  changePassword: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  toggleFiltersOpen: PropTypes.func.isRequired,
  loadAllReportData: PropTypes.func.isRequired,
};

Bar.defaultProps = {
  filtersOpen: true,
  userName: '',
};

export default Bar;
